// Contact.js
import { useState } from 'react';
import '../css/Contact.css';
import boxArrowIcon from '../icons/box-arrow-up-left.svg';
import copyIcon from '../icons/copy.svg';
// import resume from '../resume/Lucas_Aurelio_Resume.pdf';
// import resume from '../resume/Lucas_Aurelio_Resume.pdf';

function Contact(/* { onViewResume } */) {
    const [copyMessage, setCopyMessage] = useState('');
    const email = 'lucas.aurelio.n@gmail.com';

    // Copy email to clipboard
    const handleCopyEmail = () => {
        navigator.clipboard.writeText(email).then(() => {
            setCopyMessage('Copied!');
            setTimeout(() => setCopyMessage(''), 2000);
        }).catch(err => {
            console.error('Failed to copy:', err);
        });
    };

    return (
        <div className="contact-content">
            <p>Email me: <a href={`mailto:${email}`}>
                {email} <img src={boxArrowIcon} alt="" className="link-icon" />
            </a>
                <button onClick={handleCopyEmail} className="copy-button" title="Copy email">
                    <img src={copyIcon} alt="Copy" className="copy-icon" />
                </button>
                {copyMessage && <span className="copy-message">{copyMessage}</span>}
            </p>
            {/* <p>LinkedIn: <a href="https://www.linkedin.com/in/lucas-aurelio-n" target="_blank" rel="noopener noreferrer">
                linkedin.com/in/lucas-aurelio-n <img src={boxArrowIcon} alt="" className="link-icon" />
            </a></p>
            <p>GitHub: <a href="https://github.com/Lucas11011" target="_blank" rel="noopener noreferrer">
                github.com/Lucas11011 <img src={boxArrowIcon} alt="" className="link-icon" />
            </a></p>
            <p><a href={resume} onClick={(event) => {
                event.preventDefault();
                onViewResume();
            }}>
                View Resume <img src={boxArrowIcon} alt="" className="link-icon" />
            </a></p> */}
        </div>
    );
}

export default Contact;
